import { render, staticRenderFns } from "./LazyloadDefaultLayout.vue?vue&type=template&id=387805cd&scoped=true"
import script from "./LazyloadDefaultLayout.vue?vue&type=script&lang=js"
export * from "./LazyloadDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387805cd",
  null
  
)

export default component.exports